<template>
  <el-dialog
    custom-class="shareListDialogClass"
    :visible="visible"
    width="800px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <header slot="title">
      <div class="title">
        {{ $t('shareList.title') }}
        <el-button
          type="primary"
          size="small"
          :disabled="selectedShareList.length === 0"
          @click="handleDelete"
        >
          {{ $t('shareList.delete') }}
        </el-button>
      </div>
    </header>
    <el-table
      :data="shareList"
      style="width: 100%"
      v-loading="tableLoading"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        prop="projectName"
        :label="$t('projectInfo.projectName')"
      >
        <template slot-scope="scope">
          {{ scope.row.projectName || '--'  }}
        </template>
      </el-table-column>
      <el-table-column
        prop="projectName"
        :label="$t('shareList.vulnNum')"
      >
        <template slot-scope="scope">
          {{ scope.row.vulInfos.length }}
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        :label="$t('shareList.createdAt')"
      >
        <template slot-scope="scope">
          {{ formatDate(scope.row.createdAt) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="validityDays"
        :label="$t('shareList.expired')"
        width="100"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.validityDays">
            {{ scope.row.validityDays }} {{ $t('shareList.expiredDays') }}
          </span>
          <span
            style="color: #F56C6C"
            v-else
          >
            {{ $t('shareList.expired') }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="taskId"
        width="120"
        :label="$t('shareList.vulnerability')"
      >
        <template slot-scope="scope">
          <el-button
            class="vulView"
            size="mini"
            :disabled="!scope.row.validityDays"
            @click="handleVulTagClick(scope.row)"
          >
            {{ $t('ReportsView.VIEW') }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
        type="selection"
        width="55"
      />
    </el-table>
    <footer class="footer">
      <span>
        {{ $t('shareList.expiredShares', { days: 3 }) }}
      </span>
      <el-pagination
        :pager-count="5"
        :page-size="queryForm.size"
        :total="total"
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </footer>
  </el-dialog>
</template>

<script>
import { getShareList, deleteShareList } from '@/api/base';
import { dateLocaleFormat } from '@/lib/date-format';
import { createShareUrl } from './share';
import { mapGetters } from 'vuex';

export default {
  name: 'ShareList',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      shareList: [],
      total: 0,
      queryForm: {
        page: 1,
        size: 5,
      },
      selectedShareList: [],
      tableLoading: false,
    };
  },
  created() {
    this.getShareList();
  },
  computed: {
    ...mapGetters('common', ['locale']),
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    handleVulTagClick(row) {
      const shareUrl = createShareUrl(row.taskId, row.shareId);

      window.open(shareUrl, '_blank');
    },
    handleDelete() {
      this.$confirm(this.$t('shareList.deleteConfirm'), this.$t('shareList.deleteConfirmTitle'), {
        confirmButtonText: this.$t('shareList.deleteConfirmButton'),
        cancelButtonText: this.$t('shareList.deleteCancelButton'),
        type: 'warning',
      }).then(() => {
        const params = {
          shareIds: this.selectedShareList.map((item) => item.shareId),
        };
        deleteShareList(params).then(() => {
          this.selectedShareList = [];
          this.getShareList();
        });
      });
    },
    handleSelectionChange(val) {
      this.selectedShareList = val;
    },
    getShareList() {
      this.tableLoading = true;
      getShareList({
        page: this.queryForm.page - 1,
        size: this.queryForm.size,
      })
        .then((res) => {
          this.shareList = res.data;
          this.total = res.total;
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    handleCurrentChange(page) {
      this.queryForm.page = page;
      this.getShareList();
    },
    handleSizeChange(size) {
      this.queryForm.size = size;
      this.getShareList();
    },
    formatDate(date) {
      return dateLocaleFormat(date, this.locale);
    },
  },
};
</script>

<style lang="scss">
.shareListDialogClass {
  .el-dialog__header {
    padding: 16px 20px;

    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 2em;
      font-size: 20px;
      font-weight: bold;
    }
  }

  .el-dialog__body {
    padding: 0 20px 16px;
  }

  .footer {
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>